import { combineReducers } from 'redux';

import matchReducer from './slices/match';
import walletReducer from './slices/wallet';
import ticketReducer from './slices/ticket';
import lotteryReducer from './slices/lottery'
import vendorReducer from './slices/vendor';
import counterReducer from './slices/counter';
import betslipReducer from './slices/betslip';
import generaleReducer from './slices/generale';
import brbReducer from './slices/brb';

// ----------------------------------------------------------------------

export const rootReducer = combineReducers({
  counter: counterReducer,
  betslip: betslipReducer,
  generale: generaleReducer,
  wallet: walletReducer,
  ticket: ticketReducer,
  lottery: lotteryReducer,
  vendor: vendorReducer,
  match: matchReducer,
  brb: brbReducer,
});
